import { SettingsIcon } from '../../Brand/Icon';
import React from "react";
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';

export default function ButtonSettings() {
	const { t } = useTranslation();
	return (
		<AnimatedLink aria-label={t('user.settings')} to={url(`${APP_ROUTES.USER_SETTINGS}`)}>
			<SettingsIcon className="nav-icon" />
		</AnimatedLink>
	)
};
